import { UsersThree } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Matrix } from "../diagrams";

export function AgeSection() {
  return (
    <SectionShell
      id="age"
      eyebrow="Age Adaptation"
      eyebrowIcon={UsersThree}
      title="One system, maturing gracefully"
      description="The same architecture, tokens and components flex across three bands. Nothing is rebuilt — only scale, density, audio and reading level shift, so the experience grows up without ever feeling childish."
    >
      <Matrix
        firstColLabel="Dimension"
        columns={["Years 1–2", "Years 3–4", "Years 5–6"]}
        rows={[
          { label: "Touch targets", values: ["Extra large (56px+)", "Large (48px)", "Large (48px)"] },
          { label: "Illustration", values: ["Rich & constant", "Supportive", "Minimal, purposeful"] },
          { label: "Audio", values: ["Auto-narrated", "On-demand", "Optional"] },
          { label: "Learning style", values: ["Story & play", "Story + questions", "Text & questions"] },
          { label: "Animation", values: ["Expressive & big", "Standard & delightful", "Subtle & quiet"] },
          { label: "Reading load", values: ["Almost none", "Growing", "Primary mode"] },
          { label: "Independence", values: ["Guided step-by-step", "Some choice", "Self-directed"] },
          { label: "Rewards", values: ["Big celebrations", "Balanced", "Understated"] },
        ]}
      />
      <p className="mt-5 rounded-3xl border border-border bg-accent/50 p-5 font-medium text-foreground">
        The child's <strong>Year Group</strong> (set in Profile) is the single dial that orchestrates all of the above — automatically and consistently across every area.
      </p>
    </SectionShell>
  );
}

export default AgeSection;
